/* Single product page behaviour (pdp-* sections) */
(function () {
  'use strict';

  function money(cents, format) {
    format = format || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function fmt(v, p, t, d) {
      var parts = (v / 100).toFixed(p).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? d + parts[1] : '');
    }
    var map = {
      amount: fmt(cents, 2, ',', '.'),
      amount_no_decimals: fmt(cents, 0, ',', '.'),
      amount_with_comma_separator: fmt(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_space_separator: fmt(cents, 2, ' ', ','),
      amount_with_apostrophe_separator: fmt(cents, 2, "'", '.')
    };
    return format.replace(/\{\{\s*\w+\s*\}\}/, map[key] || map.amount).replace(/<[^>]*>/g, '');
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ---------- Promo end date: shared by the bar and the "sale ends in" lines ---------- */
  function promoEnd() {
    var el = document.querySelector('[data-pdp-end]');
    var t = el ? Date.parse(el.getAttribute('data-pdp-end')) : NaN;
    return isNaN(t) ? null : t;
  }
  function initClocks() {
    var end = promoEnd();
    var bars = document.querySelectorAll('[data-pdp-promo]');
    var lines = document.querySelectorAll('[data-pdp-hurry]');
    if (!end) { lines.forEach(function (l) { l.hidden = true; }); return; }
    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      bars.forEach(function (b) {
        b.querySelector('[data-d]').textContent = pad(d);
        b.querySelector('[data-h]').textContent = pad(h);
        b.querySelector('[data-m]').textContent = pad(m);
        b.querySelector('[data-s]').textContent = pad(sec);
        if (!left) b.hidden = true;
      });
      lines.forEach(function (l) {
        l.querySelector('b').textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
        if (!left) l.hidden = true;
      });
      return left > 0;
    }
    if (tick()) { var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000); }
  }

  /* ---------- Generic slider (gallery + banner) ---------- */
  function initSlider(root) {
    var slides = root.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    var thumbs = root.querySelectorAll('[data-thumb]');
    var dots = root.querySelectorAll('[data-dot]');
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    root.api = { show: show, ids: Array.prototype.map.call(slides, function (s) { return s.getAttribute('data-slide'); }) };
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); stop(); });
    if (next) next.addEventListener('click', function () { show(i + 1); stop(); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); stop(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); stop(); }); });

    var stage = root.querySelector('[data-stage]') || root;
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { show(dx < 0 ? i + 1 : i - 1); stop(); }
      x0 = null;
    });

    var timer = null;
    var auto = parseInt(root.getAttribute('data-autoplay'), 10);
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (auto > 0) timer = setInterval(function () { show(i + 1); }, auto * 1000);
  }

  /* ---------- Buy box: options, bundles, picks, price ---------- */
  function initBuy(root) {
    var cfgEl = root.querySelector('[data-pdp-json]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var form = root.querySelector('form');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var btn = form.querySelector('.pdp-cta');
    var btnLabel = btn.querySelector('[data-label]');
    var variant = cfg.variants.filter(function (v) { return v.id === cfg.current; })[0] || cfg.variants[0];
    var qty = 1;
    var discount = 0;

    function render() {
      idInput.value = variant.id;
      qtyInput.value = qty;
      var base = variant.price * qty;
      var total = Math.round(base * (100 - discount) / 100);
      var listUnit = (variant.compare_at_price && variant.compare_at_price > variant.price) ? variant.compare_at_price : variant.price;
      var compare = listUnit * qty > total ? listUnit * qty : 0;
      var extra = 0;
      root.querySelectorAll('[data-upsell]').forEach(function (u) {
        var on = u.querySelector('input').checked;
        u.classList.toggle('is-on', on);
        if (on) extra += parseInt(u.getAttribute('data-price'), 10) || 0;
      });
      total += extra;
      if (compare) compare += extra;
      root.querySelectorAll('[data-now]').forEach(function (e) { e.textContent = money(total, cfg.format); });
      root.querySelectorAll('[data-was]').forEach(function (e) { e.textContent = compare ? money(compare, cfg.format) : ''; e.hidden = !compare; });
      root.querySelectorAll('[data-off]').forEach(function (e) {
        var pct = compare ? Math.round((compare - total) * 100 / compare) : 0;
        e.hidden = !pct; e.textContent = pct + (e.getAttribute('data-suffix') || '% OFF');
      });
      root.querySelectorAll('[data-per]').forEach(function (e) {
        var servings = parseInt(e.getAttribute('data-servings'), 10) || 0;
        e.hidden = !servings;
        if (servings) e.textContent = money(Math.round(total / (servings * qty)), cfg.format) + ' ' + e.getAttribute('data-text');
      });
      root.querySelectorAll('[data-bundle]').forEach(function (b) {
        var q = parseInt(b.getAttribute('data-qty'), 10) || 1;
        var dsc = parseInt(b.getAttribute('data-discount'), 10) || 0;
        var unit = Math.round(variant.price * (100 - dsc) / 100);
        var lu = variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price;
        var rn = b.querySelector('[data-row-now]');
        if (rn) rn.textContent = money(unit * q, cfg.format);
        var rw = b.querySelector('[data-row-was]');
        if (rw) { rw.hidden = lu * q <= unit * q; rw.textContent = money(lu * q, cfg.format); }
        var sv = b.querySelector('[data-save]');
        if (sv) {
          var save = lu * q - unit * q;
          sv.hidden = save <= 0; if (save > 0) sv.textContent = (sv.getAttribute('data-text') || 'Save') + ' ' + money(save, cfg.format);
        }
      });
      btn.disabled = !variant.available;
      if (btnLabel) btnLabel.textContent = variant.available ? btnLabel.getAttribute('data-label') : btnLabel.getAttribute('data-soldout');
      var sticky = document.querySelector('[data-sticky-price]');
      if (sticky && root.hasAttribute('data-main')) sticky.textContent = money(total, cfg.format);
    }

    /* Real product options */
    var groups = root.querySelectorAll('[data-option]');
    groups.forEach(function (g) {
      g.querySelectorAll('.pdp-pill').forEach(function (p) {
        p.addEventListener('click', function () {
          g.querySelectorAll('.pdp-pill').forEach(function (x) { x.classList.toggle('is-active', x === p); x.setAttribute('aria-pressed', x === p); });
          if (g.hasAttribute('data-real')) {
            var chosen = [];
            groups.forEach(function (gg) { if (gg.hasAttribute('data-real')) { var a = gg.querySelector('.pdp-pill.is-active'); chosen.push(a ? a.getAttribute('data-value') : null); } });
            var match = cfg.variants.filter(function (v) { return v.options.every(function (o, k) { return o === chosen[k]; }); })[0];
            if (match) {
              variant = match;
              var gal = root.querySelector('[data-pdp-gallery]');
              if (match.media && gal && gal.api) { var idx = gal.api.ids.indexOf(String(match.media)); if (idx > -1) gal.api.show(idx); }
            }
          } else {
            var input = g.querySelector('input[type="hidden"]');
            if (input) input.value = p.getAttribute('data-value');
          }
          render();
        });
      });
    });

    /* Bundles = quantity */
    root.querySelectorAll('[data-bundle]').forEach(function (b, k, all) {
      b.addEventListener('click', function () {
        all.forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); });
        qty = parseInt(b.getAttribute('data-qty'), 10) || 1;
        discount = parseInt(b.getAttribute('data-discount'), 10) || 0;
        var prop = form.querySelector('[data-bundle-prop]');
        if (prop) prop.value = b.getAttribute('data-name');
        render();
      });
      if (b.classList.contains('is-active')) {
        qty = parseInt(b.getAttribute('data-qty'), 10) || 1;
        discount = parseInt(b.getAttribute('data-discount'), 10) || 0;
      }
    });

    /* Free picks (limited) */
    var picks = root.querySelectorAll('.pdp-pick');
    var maxPick = parseInt(root.getAttribute('data-pick-max'), 10) || picks.length;
    var pickProp = form.querySelector('[data-picks-prop]');
    function syncPicks() {
      var on = Array.prototype.filter.call(picks, function (p) { return p.querySelector('input').checked; });
      picks.forEach(function (p) {
        p.classList.toggle('is-on', p.querySelector('input').checked);
        p.classList.toggle('is-locked', on.length >= maxPick);
      });
      if (pickProp) pickProp.value = on.map(function (p) { return p.getAttribute('data-name'); }).join(', ');
      var counter = root.querySelector('[data-pick-count]');
      if (counter) counter.textContent = on.length + '/' + maxPick;
    }
    picks.forEach(function (p) {
      var input = p.querySelector('input');
      input.addEventListener('change', function () {
        var on = root.querySelectorAll('.pdp-pick input:checked').length;
        if (input.checked && on > maxPick) input.checked = false;
        syncPicks();
      });
    });
    syncPicks();

    root.querySelectorAll('[data-upsell] input').forEach(function (inp) { inp.addEventListener('change', render); });

    /* Add everything in one request, then go to checkout with the bundle's code */
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (btn.disabled) return;
      var err = form.querySelector('[data-error]');
      if (err) err.hidden = true;
      var props = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (i) {
        if (i.value) props[i.name.slice(11, -1)] = i.value;
      });
      var items = [{ id: Number(idInput.value), quantity: qty, properties: props }];
      root.querySelectorAll('[data-gift]').forEach(function (g) {
        items.push({ id: Number(g.getAttribute('data-gift')), quantity: 1, properties: { _offer: 'Included gift' } });
      });
      root.querySelectorAll('.pdp-pick[data-variant]').forEach(function (k) {
        if (k.querySelector('input').checked) items.push({ id: Number(k.getAttribute('data-variant')), quantity: 1, properties: { _offer: 'Free pick' } });
      });
      root.querySelectorAll('[data-upsell]').forEach(function (u) {
        if (u.querySelector('input').checked) items.push({ id: Number(u.getAttribute('data-upsell')), quantity: 1, properties: { _offer: 'Upsell' } });
      });
      var active = root.querySelector('[data-bundle].is-active');
      var code = active ? active.getAttribute('data-code') : '';
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var dest = form.getAttribute('data-after') === 'cart' ? rootUrl + 'cart' : rootUrl + 'checkout';
      btn.classList.add('is-loading'); btn.disabled = true;
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
          window.location.href = code ? rootUrl + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest) : dest;
        })
        .catch(function (ex) {
          btn.classList.remove('is-loading'); btn.disabled = false;
          if (err) { err.textContent = ex.message; err.hidden = false; }
        });
    });

    render();
  }

  /* ---------- Reviews carousel arrows ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    function step() { var c = track.querySelector('.pdp-rc__card'); return c ? c.getBoundingClientRect().width + 20 : track.clientWidth; }
    root.querySelectorAll('[data-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.getAttribute('data-dir') === 'next' ? 1 : -1;
        var max = track.scrollWidth - track.clientWidth - 4;
        if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0 });
        else if (dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth });
        else track.scrollBy({ left: dir * step() });
      });
    });
  }

  /* ---------- Review list: load more ---------- */
  function initReviewList(root) {
    var btn = root.querySelector('[data-more]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var hidden = root.querySelectorAll('.pdp-rl__item[hidden]');
      Array.prototype.slice.call(hidden, 0, 4).forEach(function (el) { el.hidden = false; });
      if (root.querySelectorAll('.pdp-rl__item[hidden]').length === 0) btn.remove();
    });
  }

  /* ---------- Sticky buy bar ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-pdp-sticky]');
    var target = document.querySelector('[data-main] .pdp-cta');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var past = false;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
    }).observe(target);
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!document.documentElement.classList.contains('pdp-anim') || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Smooth anchors ---------- */
  function initAnchors() {
    document.querySelectorAll('a[href="#pdp-buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('pdp-buy');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Copy coupon code ---------- */
  function initCopy() {
    document.querySelectorAll('[data-copy]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-copy');
        var done = function () {
          var t = b.querySelector('[data-copied]'); if (!t) return;
          t.hidden = false; b.classList.add('is-copied');
          setTimeout(function () { t.hidden = true; b.classList.remove('is-copied'); }, 1600);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
    });
  }

  function init() {
    initCopy();
    initClocks();
    document.querySelectorAll('[data-pdp-slider]').forEach(initSlider);
    document.querySelectorAll('[data-pdp-buy]').forEach(initBuy);
    document.querySelectorAll('[data-pdp-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-pdp-reviews]').forEach(initReviewList);
    initSticky();
    initReveal();
    initAnchors();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
